<template>
  <div id="appCapsule">
    <div class="history-section">
      <div class="app-history-card">
        <div class="mt-mtransactions">
          <!-- <div class="card-header-sortbydate">
                        <div class="card-hry-sortbydate-col">
                            <form method="POST" class="sortHistory">
                                <div class="sortbydate-input-group">
                                    <input
                                        type="date"
                                        id="start_date"
                                        name="start_date"
                                        value="2022-04-02"
                                        class="sortbydate-input"
                                    />
                                    <input
                                        type="hidden"
                                        id="sort_acc_number"
                                        name="sort_acc_number"
                                        value="06024563092"
                                    />
                                    <button
                                        type="submit"
                                        class="sortbydate-submit"
                                    >
                                        GO
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="card-hry-sortbydate-col">
                            <div class="sortbydate-export">
                                <button class="sortbydate-export-btn">
                                    <span class="stdt-export-btn-icon">
                                        <svg
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15"
                                            height="15"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                d="M11 12v6.586l-2.293-2.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l4 4c0.092 0.092 0.202 0.166 0.324 0.217 0.245 0.101 0.521 0.101 0.766 0 0.118-0.049 0.228-0.121 0.324-0.217l4-4c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-2.293 2.293v-6.586c0-0.552-0.448-1-1-1s-1 0.448-1 1zM21.455 18.908c1.355-0.953 2.196-2.367 2.46-3.878s-0.050-3.126-1.003-4.481c-0.825-1.174-1.998-1.963-3.287-2.324-0.526-0.147-1.072-0.223-1.621-0.225h-0.523c-0.722-2.058-2.137-3.71-3.907-4.758-1.981-1.172-4.412-1.589-6.819-0.972s-4.338 2.155-5.51 4.136-1.589 4.412-0.972 6.819c0.371 1.446 1.075 2.725 1.983 3.734 0.37 0.41 1.002 0.444 1.412 0.074s0.444-1.002 0.074-1.412c-0.692-0.769-1.242-1.76-1.533-2.893-0.481-1.873-0.157-3.761 0.756-5.304s2.412-2.736 4.285-3.216 3.761-0.157 5.304 0.756 2.736 2.412 3.216 4.285c0.116 0.435 0.506 0.751 0.97 0.751h1.256c0.37 0.001 0.737 0.052 1.090 0.151 0.861 0.241 1.639 0.765 2.19 1.548 0.636 0.904 0.845 1.978 0.669 2.988s-0.736 1.95-1.64 2.585c-0.452 0.318-0.56 0.941-0.243 1.393s0.941 0.56 1.393 0.243z"
                                            ></path>
                                        </svg>
                                    </span>
                                    <span>Export</span>
                                </button>
                            </div>
                        </div>
                    </div> -->

          <div class="app-transaction-history">
            <ul id="transactionHistory" class="list-unstyled mg-b-0">
              <span v-for="log in logs" :key="log.id">
                <li
                  v-if="log.is_credit == 1"
                  class="list-item mt-trs-li credit"
                  @click.prevent="viewData(log.id, log.is_transfer)"
                >
                  <div class="media align-items-center">
                    <div class="mt-trs-icon-group">
                      <div class="mt-trs-icon-avatar">
                        <span class="mt-trs-icon-avatar-txt">{{
                          log.type
                        }}</span>
                      </div>
                      <div
                        class="mtx-info wd-35 ht-35 bd bd-2 bd-info rounded-circle align-items-center justify-content-center d-sm-flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="32"
                            d="M416 128L192 384l-96-96"
                          ></path>
                        </svg>
                      </div>
                    </div>

                    <div class="media-body mg-sm-l-15">
                      <p class="mt-trs-details tx-medium mg-b-0">
                        {{ log.detail.slice(0, 20) }}
                      </p>
                      <p class="mt-trs-date tx-12 mg-b-0 tx-color-03">
                        {{ new Date(log.created_at).toDateString() }}
                      </p>
                    </div>
                    <!-- media-body -->
                  </div>
                  <!-- media -->
                  <div class="text-right tx-rubik">
                    <p class="mt-trs-amt mg-b-0">
                      +{{ log.currency.symbol }}{{ log.amount }} ({{
                        log.currency.code
                      }})
                    </p>
                    <p class="mt-trs-status tx-12 mg-b-0 tx-success">
                      <span class="itrr-type">Credit</span>
                      Completed
                    </p>
                  </div>
                  <!-- media-body -->
                </li>

                <li
                  v-if="log.is_credit == 0"
                  class="list-item mt-trs-li debit"
                  @click.prevent="viewData(log.id, log.is_transfer)"
                >
                  <div class="media align-items-center">
                    <div class="mt-trs-icon-group">
                      <div class="mt-trs-icon-avatar">
                        <span class="mt-trs-icon-avatar-txt">
                          {{ log.type }}
                        </span>
                      </div>
                      <div
                        class="mtx-info wd-35 ht-35 bd bd-2 bd-info rounded-circle align-items-center justify-content-center d-sm-flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="32"
                            d="M416 128L192 384l-96-96"
                          ></path>
                        </svg>
                      </div>
                    </div>

                    <div class="media-body mg-sm-l-15">
                      <p class="mt-trs-details tx-medium mg-b-0">
                        {{ log.detail.slice(0, 20) }}
                      </p>
                      <p class="mt-trs-date tx-12 mg-b-0 tx-color-03">
                        {{ new Date(log.created_at).toDateString() }}
                      </p>
                    </div>
                    <!-- media-body -->
                  </div>
                  <!-- media -->
                  <div class="text-right tx-rubik">
                    <p class="mt-trs-amt mg-b-0">
                      -{{ log.currency.symbol }}{{ log.amount }} ({{
                        log.currency.code
                      }})
                    </p>
                    <p
                      v-if="log.status == 1"
                      class="mt-trs-status tx-12 mg-b-0 tx-success"
                    >
                      <span class="itrr-type">Debit</span>
                      Completed
                    </p>
                    <p
                      v-if="log.status == 0"
                      style="color: orange"
                      class="mt-trs-status tx-12 mg-b-0"
                    >
                      <span class="itrr-type">Debit</span>
                      Pending
                    </p>
                  </div>
                  <!-- media-body -->
                </li>
              </span>

              <div class="master-pagination">
                <ul class="pagination mg-b-0">
                  <li class="page-item disabled" @click.prevent="prev">
                    <a
                      class="page-link page-link-icon"
                      onclick="historyPages('0', '04100211846');"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-chevron-left"
                      >
                        <polyline points="15 18 9 12 15 6"></polyline></svg
                    ></a>
                  </li>

                  <li class="page-item active">
                    <a class="page-link">
                      {{ logData.current_page }}
                    </a>
                  </li>

                  <li class="page-item">
                    <a class="page-link" href="javascript:void(0);">3</a>
                  </li>

                  <li v-if="logData.next_page_url">
                    <a
                      @click.prevent="next"
                      class="page-link page-link-icon"
                      href="javascript:void(0);"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-chevron-right"
                      >
                        <polyline points="9 18 15 12 9 6"></polyline></svg
                    ></a>
                  </li>
                </ul>
              </div>
            </ul>
            <div id="actionLoader"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '../../../repository/RepositoryFactory';

const UsersRepository = RepositoryFactory.get('users');
import axios from '../../../repository/Base';
export default {
  data() {
    return {
      account: {},
      user: {},
      logs: [],
      logData: {},
    };
  },
  methods: {
    viewData(id, type) {
      viewHis(id, type);
    },
    async prev() {
      try {
        const nextPage = this.logData.from - 1;
        if (this.logData.prev_page_url == null || nextPage == 0) return;
        const response = await UsersRepository.logsData(nextPage);
        this.logData = response.data.logs;
        this.logs = response.data.logs.data;
      } catch (e) {
        console.log(e);
      }
    },
    async next() {
      try {
        const nextPage = this.logData.from + 1;
        if (this.logData.next_page_url == null || nextPage > this.logData.total)
          return;
        const response = await UsersRepository.logsData(nextPage);
        this.logData = response.data.logs;
        this.logs = response.data.logs.data;
      } catch (error) {
        console.log(error);
      }
    },
    userAccounts() {
      UsersRepository.loggedInUser().then((response) => {
        this.user = response.data;
        this.logs = response.data.logs.data;
        this.logData = response.data.logs;
        UsersRepository.viewAccounts(response.data.id).then((res) => {
          this.account = res.data;
        });
      });
    },
    transactionModal() {
      $('#modal-transactions').modal('show');
    },
    showModal() {
      $('#modal-invest').modal('show');
    },
  },

  created() {
    this.userAccounts();
  },
};
</script>
